import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';


import { Centered, CircularProgress, Paper, Typography } from "../../../../common/components/libs";
import styles from "./style.module.css"
import NoCategories from "./components/NoCategories";
import { FadeInOutVertical } from "../../../../common/components/Animated";
import EditMenuCategoryForm from "./components/EditMenuBookingCategoryForm";
import CategoriesTabs from "./components/MenuCategories";
import EditBookingItemForm from "./components/EditBookingItemForm";
import CreateMenuItemForm from "./components/CreateMenuBookingForm";
import NoMenuItems from "./components/NoMenuItems";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import { useParams } from "react-router-dom";
import { localize } from "../../../../common/libs";
import EditMenuCategoriesForm from "./components/EditMenuCategoriesForm";
import { useHistory } from "react-router-dom";
import EditMenuItemsOrdersForm from "./components/EditMenuItemsOrdersForm";
import HeaderButton from "./components/HeaderButton";
import {useTranslation} from "react-i18next";
import DeleteMenuCategoryForm from "./components/DeleteMenuCategoryForm";
import CopyBookingItemForm from "./components/CopyBookingItemForm";


const MenuEditorPage = () => {
    const { bookingStore, generalStore, translationStore } = useStores();

    const [isLoading, setIsLoading] = useState(true);
    const { menuId } = useParams();
    const history = useHistory();
    const {t} = useTranslation(["general", "menu"]);

    const navigateTo = (link: string) => {
        history.push(link);
    };
    useEffect(() => {
        bookingStore.fetchMenuById(menuId);
    }, [menuId, bookingStore]);

    useEffect(() => {
        const menu = bookingStore.currentMenu?.menu;
        if (!menu) return;
        generalStore.setPageTitle(localize(menu.data.name), <HeaderButton/>);
        translationStore.setLangs(menu.data.availableLanguages);
        setIsLoading(false);

    }, [bookingStore.currentMenu, generalStore]);


    const { currentMenu, selectedCategory } = bookingStore;

    if (!currentMenu || isLoading) {
        return <FadeInOutVertical show={!isLoading}>
            <Centered>
                <Paper mt={2} style={{ padding: 40 }}>
                    <Typography variant="body2">
                        {t("general:loading")}
                    </Typography>
                    <CircularProgress m={2}/>
                </Paper>
            </Centered>
        </FadeInOutVertical>
    }
    const { menuCategories } = currentMenu;


    const renderCategoryContent = () => {
        const currentCategory = menuCategories[selectedCategory];
        if (!currentCategory) return null;

        const { menuItemsByCategoryId } = currentMenu;
        const menuItems = menuItemsByCategoryId[currentCategory.id] || [];
        if (menuItems.length > 0) {
            return menuItems.map(item => {
                return <FadeInOutVertical show={true} key={item.id}>
                    <Paper mb={4}>
                        <div style={{ padding: "20px 20px 15px 20px" }}
                             onClick={(e) => {
                                 navigateTo(
                                     `/menus/booking/${bookingStore.currentMenu.id}/${currentCategory.id}/${item.id}`
                                 )
                             }}
                        >
                            <EditBookingItemForm
                                key={item.id}
                                category={currentCategory}
                                current={item}
                            />
                        </div>
                    </Paper>
                </FadeInOutVertical>
            })
        } else {
            return <FadeInOutVertical show={true}>
                <Centered>
                    <NoMenuItems/>
                </Centered>
            </FadeInOutVertical>
        }
    };
    let content = [];

    if (menuCategories.length === 0) {
        content.push(
            <FadeInOutVertical show={true}
                               key="1"
            >
                <Centered>
                    <NoCategories/>
                </Centered>
            </FadeInOutVertical>
        )
    } else {
        content.push(
            <FadeInOutVertical show={true} key='2'>
                <div className={styles.menuEditorContainer}>
                    <CategoriesTabs/>
                </div>
            </FadeInOutVertical>
        );
        content.push(
            <FadeInOutVertical show={true} key={'3'}>
                <div className={styles.menuItemsContainer}>
                    {renderCategoryContent()}
                </div>
            </FadeInOutVertical>
        )
    }

    return (
        <>
            <Helmet title={t("menu:menuEditor.yourMenus")}/>
            {content}
            <CopyBookingItemForm/>
            <CreateMenuItemForm/>
            <EditMenuCategoryForm/>
            <EditMenuCategoriesForm/>
            <EditMenuItemsOrdersForm/>
            <DeleteMenuCategoryForm/>
        </>
    );

};

export default observer(MenuEditorPage);
